import { guid, Records } from "@buildwithflux/shared";
import { keys } from "lodash";
import { handleRemoveDocumentProperties, handleSetDocumentProperties } from "../document-actions";
/**
 * Applies a project properties action by updating the document properties
 */
export function applyProjectPropertiesAction(action, document) {
    const documentProperties = document.properties;
    const documentPropertyUidsToRemove = action.projectPropertiesToRemove
        .map((propertyName) => {
        const property = Records.findValue(documentProperties || {}, (property) => property.name === propertyName);
        return property?.uid;
    })
        .filter((propertyUid) => propertyUid !== undefined);
    if (documentPropertyUidsToRemove.length > 0) {
        handleRemoveDocumentProperties(document, documentPropertyUidsToRemove);
    }
    const documentPropertiesToSet = action.projectPropertiesToAddOrEdit.reduce((acc, property) => {
        const existingProperty = Records.findValue(documentProperties || {}, (existingProperty) => existingProperty.name === property.name);
        if (existingProperty) {
            const updatedProp = {
                ...existingProperty,
                value: property.value,
                unit: property.unit || existingProperty.unit,
            };
            return {
                ...acc,
                [existingProperty.uid]: updatedProp,
            };
        }
        else {
            const uid = guid();
            const newProp = {
                uid: uid,
                name: property.name,
                value: property.value,
                unit: property.unit ?? undefined,
            };
            return {
                ...acc,
                [uid]: newProp,
            };
        }
    }, {});
    if (keys(documentPropertiesToSet).length > 0) {
        handleSetDocumentProperties(document, documentPropertiesToSet);
    }
    return {
        projectPropertiesAdded: Object.values(documentPropertiesToSet).map((p) => ({
            name: p.name,
            value: p.value.toString(),
        })),
        projectPropertiesRemoved: [...action.projectPropertiesToRemove],
    };
}
//# sourceMappingURL=applyProjectPropertiesAction.js.map